<template>
  <div class="ddmjcx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
              <el-button :loading="btnLoading" icon="el-icon-printer" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.orderNum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.productNum!==null&&scope.row.productNum!==''&&scope.row.productNum!==undefined">{{scope.row.productNum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.productNum===null||scope.row.productNum===''||scope.row.productNum===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.allName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderType===0">正单</span>
                      <span v-if="scope.row.orderType===1">客改单</span>
                      <span v-if="scope.row.orderType===2">增补单</span>
                      <span v-if="scope.row.orderType===3">色板单</span>
                      <span v-if="scope.row.orderType===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产车间"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.factoryName===''">无</span>
                      <span v-if="scope.row.factoryName!==''">{{ scope.row.factoryName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="设计师"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                      <span v-if="scope.row.splitName!==''&&scope.row.splitName!==null">{{ scope.row.splitName }}</span>
                      <span v-if="scope.row.splitName===''||scope.row.splitName===null" style="color: #99a9bf;">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="当前状态"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    min-width="200"
                    label="木架信息"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.woodStr===''" style="color:#99a9bf">无</span>
                      <span v-if="scope.row.woodStr!==''">{{scope.row.woodStr}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  style="margin-top: 20px;"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { getUser } from '@/utils/auth'
import { getMakingOrderList, exportGetMakingOrderList, getFactoryList, getGroupInfoByUser } from '@/api/erp'

export default {
  name: 'ddmjcx',
  data() {
    return {
      btnLoading: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      factoryList: [],
      searchForm: {
        search: '',
        type: '',
        state: '',
        factory: ''
      },
      group: {
        dBrand: 1
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    this.getFactoryList()
  },
  methods: {
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    getData() {
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        factory: this.searchForm.factory
      }
      this.loading = true
      getMakingOrderList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        console.log(response.data)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    exportExcel() {
      const data = {
        content: this.searchForm.search,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        factory: this.searchForm.factory
      }
      this.btnLoading = true
      exportGetMakingOrderList(data).then(response => {
        debugger
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ddmjcx-container {

  .tcf-tag-1 {
    background: #E8EDF9;
    border-color: #D0DCF8;
    color: #5F8EFC;
  }

  .tcf-tag-2 {
    background: #FCE9F6;
    border-color: #FCD5F0;
    color: #F95BC9;
  }

  .tcf-tag-3 {
    background: #ECE3FC;
    border-color: #D6BFFF;
    color: #8D55F9;
  }

  .tcf-tag-4 {
    background: #FFEEE6;
    border-color: #FFDECE;
    color: #FE7530;
  }

  .tcf-tag-5 {
    background: #E8F5FF;
    border-color: #C7E7FF;
    color: #32A7FF;
  }

  .tcf-tag-6 {
    background: #EEFCFE;
    border-color: #D6F7FC;
    color: #72B5C1;
  }

  .tcf-tag-7 {
    background: #F9FBF0;
    border-color: #E3EBC1;
    color: #B1BF75;
  }

  .tcf-tag-8 {
    background: #F9ECD7;
    border-color: #F4CF97;
    color: #C5892E;
  }

  .tcf-tag-9 {
    background: #EEF1F7;
    border-color: #BBC7DA;
    color: #7A869A;
  }

  .tcf-tag-10 {
    background: #E2F5F2;
    border-color: #CAF4ED;
    color: #419488;
  }

  .tcf-tag-11 {
    background: #F5F7FE;
    border-color: #C4CBE1;
    color: #828EB7;
  }
  }
</style>
